mutation deleteSavedContentBatch($input: DeleteSavedContentBatchInput!) {
  deleteSavedContentBatch(input: $input)
}
